

































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import Fullscreen from "vue-fullscreen";
Vue.use(Fullscreen, { name: "fs" });
import {
  BIconArrowsFullscreen,
  BIconClock,
  BIconEye,
  BIconCircleFill,
  BIconMusicNoteBeamed,
  BIconInfoCircle,
  BIconBadgeVo
} from "bootstrap-vue";
import { RevolvaService } from "@/service/revolva.service";
import * as actions from "@/service/revolva.action";
import * as actionsCustom from "@/service/revolva.action-custom";

// @ts-ignore
import RangeSlider from "vue-range-slider";
import "vue-range-slider/dist/vue-range-slider.css";
import { StereoEffect } from 'three/examples/jsm/effects/StereoEffect.js';


interface Dictionary<T> {
  [Key: string]: T;
}
interface FullscreenComponent extends Element {
  getState(): boolean;
  toggle(): void;
}

@Component({
  components: {
    BIconArrowsFullscreen,
    BIconClock,
    BIconEye,
    BIconCircleFill,
    RangeSlider,
    BIconMusicNoteBeamed,
    BIconInfoCircle,
    BIconBadgeVo,
  },
})
export default class ToolBar extends Vue {
  @Prop() readonly revolva: RevolvaService | undefined;
  @Prop() readonly fullScreenToggle: Function | undefined;

  @Watch("revolva.sliderValue")
  onSliderValueChange() {
    actionsCustom.explodeMesh(this.revolva);
    actions.renderModel(this.revolva);
    if (this.revolva.seeInside) {
      this.seeInsideToggle();
    }

    if (this.revolva.animation) this.animationToggle();

    //     if (this.revolva.sliderValue > 0) {this.revolva.controlerAutoRotat = true;
    //     this.revolva.controls.autoRotate = this.revolva.controlerAutoRotat;

    //       setTimeout(() => {
    // this.revolva.controlerAutoRotat = false;    this.revolva.controls.autoRotate = this.revolva.controlerAutoRotat;  }, 500);

    //     }
    //     else {
    //        this.revolva.controlerAutoRotat = false;
    //        this.revolva.controls.autoRotate = this.revolva.controlerAutoRotat;}
  }

  public showInfoToggle() {
    this.revolva.showInfo = !this.revolva.showInfo;
    if (this.revolva.showInfo) {
      actionsCustom.showMarkerInfo(this.revolva);
    }
    if (!this.revolva.showInfo) {
      actionsCustom.removeMarkerInfo(this.revolva);
    }
    actions.renderModel(this.revolva);
  }

  public animationToggle() {
    this.revolva.animation = !this.revolva.animation;
    actions.renderModel(this.revolva);
    if (this.revolva.animation) {
      setTimeout(() => {
        this.revolva.animation = false;
      }, 30000);
    }
  }

  public seeInsideToggle() {
    this.revolva.seeInside = !this.revolva.seeInside;
    actionsCustom.seeInside(this.revolva);
    //actions.renderModel(this.revolva);
  }

  public playSound() {
    actionsCustom.playSound(this.revolva);
  }

  public showVRToggle() {
    this.revolva.isSterioEffect = !this.revolva.isSterioEffect;
    if(this.revolva.isSterioEffect){
      this.revolva.stereoEffect = new StereoEffect(this.revolva.renderer);
      this.revolva.stereoEffect.setSize(window.innerWidth, window.innerHeight);
    }
    actions.renderModel(this.revolva);
    actions.onWindowResize(this.revolva);
  }
}
